<template>
    <v-card color="primary" flat>
        <v-toolbar color="primary" dark flat dense>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-flex custom-5-col class="center-text">
                        <v-btn
                            v-on="on"
                            class="custom-btn"
                            elevation="0"
                            width="100%"
                            color="primary"
                            @click="importFile">
                            <v-icon dark>mdi-file-import</v-icon>
                        </v-btn>
                    </v-flex>
                </template>
                <span>Import File</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-flex custom-5-col class="center-text">
                        <v-btn
                            v-on="on"
                            class="custom-btn"
                            elevation="0"
                            width="100%"
                            color="primary"
                            @click="archiveOutdated">
                            <v-icon dark>mdi-archive</v-icon>
                        </v-btn>
                    </v-flex>
                </template>
                <span>Archive Overdue Tasks</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-flex custom-5-col class="center-text">
                        <v-btn
                            v-on="on"
                            class="custom-btn"
                            elevation="0"
                            width="100%"
                            color="primary"
                            @click="addTask">
                            <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                    </v-flex>
                </template>
                <span>New Job Task</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-flex custom-5-col class="center-text">
                        <v-btn
                            v-on="on"
                            class="custom-btn"
                            elevation="0"
                            width="100%"
                            color="primary"
                            @click="addRoute">
                            <v-icon dark>mdi-truck-delivery-outline</v-icon>
                        </v-btn>
                    </v-flex>
                </template>
                <span>New Route</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-flex custom-5-col class="center-text">
                        <v-btn
                            v-on="on"
                            class="custom-btn"
                            elevation="0"
                            width="100%"
                            color="primary"
                            @click="resetRouteMap">
                            <v-icon dark>mdi-map-clock-outline</v-icon>
                        </v-btn>
                    </v-flex>
                </template>
                <span>Reset Route Map</span>
            </v-tooltip>
        </v-toolbar>
    </v-card>
</template>
<script>
    export default {
        name: 'map-list-top-bar',
        props: {
            importFile: {
                type: Function,
                required: true
            },
            addTask: {
                type: Function,
                required: true
            },
            addRoute: {
                type: Function,
                required: true
            },
            resetRouteMap: {
                type: Function,
                required: true
            },
            archiveOutdated: {
                type: Function,
                required: true
            }
        }
    }
</script>
<style scoped>
    .center-text {
        text-align: center;
    }
    .custom-5-col {
        width: 20%;
        max-width: 20%;
        flex-basis: 20%;
    }
</style>
